// Salesforce 2 form controller
// Used in partials
function sfCtrl2($window, $location, $element, $cookies) {
  const { dataLayer } = $window;
  const vmt = this;

  vmt.formInputs = {};
  vmt.formView = false;
  vmt.thankYouView = false;
  vmt.config = {
    retUrl: $location.href,
    actionUrl: 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8',
    formName: $element.find('form').attr('id'),
    triedSubmit: false
  };

  vmt.sfCheckHash = () => {
    $element.find('.thankYouView').css('visibility', 'visible');
    $element.find('.retURL').attr('value', vmt.config.retUrl);

    //if session var exists
    if (sessionStorage.formSubmitted === 'true') {
      vmt.thankYouView = true;
      vmt.expertCheck();
      //destroy session var
      sessionStorage.removeItem('formSubmitted');
    } else {
      vmt.formView = true;
    }
  };

  vmt.sfSubmit = (formValid) => {
    const version = $cookies.get('version') || 'v1';

    if (version === 'v2') $element.find('#sfRecordType').val('01270000000EAWZ');

    if (formValid) {
      // create session variable
      sessionStorage.formSubmitted = 'true';

      dataLayer.push({
        event: 'formSubmit',
        formName: vmt.config.formName
      });

      $element
        .find('form')
        .attr('action', vmt.config.actionUrl)
        .submit();
    } else {
      vmt.config.triedSubmit = true;
    }
  };

  vmt.expertCheck = () => {
    $(window).on('load', () => {
      $('.becomeanexpertmodal-trigger').click();
    });
  };

  vmt.sfCheckHash();
}

sfCtrl2.$inject = ['$window', '$location', '$element', '$cookies'];

export default sfCtrl2;
